import { Link, useNavigate } from 'react-router-dom';
import { Tag } from 'antd';
import { ResourceList } from '@/components/ResourceList';
import { listWorkflows, type WorkflowTemplate } from '@/api/workflows';
import { formatDateTime } from '@/utils/format';

export function WorkflowsListPage() {
  const navigate = useNavigate();
  return (
    <ResourceList<WorkflowTemplate>
      title="工作流模板"
      description="ComfyUI / 即梦 / Flux 流的可复用模板，按 code 唯一识别，PATCH 自动 bump version。"
      rowKey="code"
      pagination="offset"
      filters={[
        { key: 'q', label: '关键字', type: 'text', placeholder: 'code 或 name' },
        {
          key: 'status',
          label: '状态',
          type: 'select',
          options: [
            { value: 'active', label: '活跃' },
            { value: 'draft', label: '草稿' },
            { value: 'archived', label: '已归档' },
          ],
        },
      ]}
      fetcher={({ filters, page, pageSize }) =>
        listWorkflows({ ...filters, page, page_size: pageSize } as never)
      }
      columns={[
        {
          title: 'Code',
          dataIndex: 'code',
          render: (v) => <Link to={`/workflows/${encodeURIComponent(v)}`}>{v}</Link>,
        },
        { title: '名称', dataIndex: 'name' },
        { title: '类型', dataIndex: 'kind', render: (v) => <Tag color="purple">{v}</Tag> },
        { title: '版本', dataIndex: 'version', align: 'right' },
        {
          title: '消耗钻石',
          dataIndex: 'cost_diamonds',
          align: 'right',
          render: (v) => v ?? 0,
        },
        { title: '状态', dataIndex: 'status', render: (v) => <Tag>{v}</Tag> },
        {
          title: '更新时间',
          dataIndex: 'updated_at',
          render: (v) => formatDateTime(v),
        },
      ]}
      actions={[
        {
          label: '查看模板列表',
          onClick: () => navigate('/workflows'),
          type: 'default',
        },
      ]}
    />
  );
}
